export const genders = {
  MR: 'Männlich',
  MS: 'Weiblich',
  MX: 'Divers',
};

export const languageSkills = {
  'Sehr gut': '<strong>Sehr gut</strong> / Deutsch ist Muttersprache',
  Gut:
    '<strong>Gut</strong> / Ich kann eine längere Unterhaltung in gutem Deutsch führen',
  Mittel:
    '<strong>Mittel</strong> / Ich kann mich grundsätzlich verständigen. (Entspricht Sprachzertifikat B1)',
};

export const driversLicences = {
  B: 'B (PKW)',
  BE: 'BE (PKW mit Anhänger bis 3,5 t)',
  C: 'C (LKW)',
  D: 'D (Bus)',
  L: 'L (Zugmaschinen bis 40 km/h)',
  T: 'T (Zugfahrzeug Land- und Forstwirtschaft)',
};

export const countries = {
  DE: 'Deutschland',
  AF: 'Afghanistan',
  EG: 'Ägypten',
  DZ: 'Algerien',
  AO: 'Angola',
  ET: 'Äthiopien',
  BE: 'Belgien',
  BJ: 'Benin',
  BA: 'Bosnien und Herzegowina',
  BR: 'Brasilien',
  BG: 'Bulgarien',
  DK: 'Dänemark',
  DO: 'Dominikanische Republik',
  EC: 'Ecuador',
  ER: 'Eritrea',
  EE: 'Estland',
  FI: 'Finnland',
  FR: 'Frankreich',
  GM: 'Gambia',
  GH: 'Ghana',
  GR: 'Griechenland',
  UK: 'Großbritannien',
  IN: 'Indien',
  IQ: 'Irak',
  IR: 'Iran',
  IE: 'Irland',
  IT: 'Italien',
  JP: 'Japan',
  CM: 'Kamerun',
  KZ: 'Kasachstan',
  KE: 'Kenia',
  KG: 'Kirgisistan',
  CO: 'Kolumbien',
  CD: 'Kongo',
  KP: 'Korea',
  XK: 'Kosovo',
  CU: 'Kuba',
  HR: 'Kroatien',
  LV: 'Lettland',
  LB: 'Libanon',
  LT: 'Litauen',
  LU: 'Luxemburg',
  MT: 'Malta',
  MA: 'Marokko',
  MD: 'Moldawien',
  ME: 'Montenegro',
  NL: 'Niederlande',
  NG: 'Nigeria',
  MK: 'Nordmazedonien',
  AT: 'Österreich',
  PK: 'Pakistan',
  PS: 'Palästina',
  PE: 'Peru',
  PH: 'Philippinen',
  PL: 'Polen',
  PT: 'Portugal',
  RO: 'Rumänien',
  RU: 'Russland',
  SV: 'El Salvador',
  SE: 'Schweden',
  SN: 'Senegal',
  RS: 'Serbien',
  SK: 'Slowakei',
  SI: 'Slowenien',
  SO: 'Somalia',
  ES: 'Spanien',
  SY: 'Syrien',
  TG: 'Togo',
  CZ: 'Tschechien',
  TN: 'Tunesien',
  TR: 'Türkei',
  UG: 'Uganda',
  UA: 'Ukraine',
  HU: 'Ungarn',
  US: 'Vereinigte Staaten',
  VN: 'Vietnam',
  BY: 'Weißrussland',
  CY: 'Zypern',
};

export const nationalities = {
  de: 'deutsch',
  other: 'andere',
};

export const contactTimes = {
  Vormittags: 'Vormittags',
  Mittags: 'Mittags',
  Nachmittags: 'Nachmittags',
};

export const yesNo = {
  yes: 'Ja',
  no: 'Nein',
};

export const noYes = {
  no: 'Nein',
  yes: 'Ja',
};
